import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils.ts';

export type HomeServiceProvider = {
  id: string;
  hspId: string;
  hspFirstname: string;
  hspLastname: string;
};

export const homeServiceProviderSchema: Schema<HomeServiceProvider> =
  cz.camelCaseObject({
    id: z.string(),
    hsp_id: z.string(),
    hsp_firstname: z.string(),
    hsp_lastname: z.string(),
  });
